import { Injectable } from '@angular/core';
import { User, Permission, PermissionChecker, PermissionAccessLevel } from '@socrates/common';
import { IPermissionsRepo } from '../repository/interfaces/ipermissions.repo';
import { I18NService } from '../directives/eighteen';

@Injectable()
export class PermissionService {

	static _allLoaded = false;
	static _permissionChecker: PermissionChecker;
	static _defaultGroups: string[] = [];

	constructor(private permissionsRepo: IPermissionsRepo) {
	}

	async loadPermissions(env: string): Promise<void> {
		if (PermissionService._allLoaded) return;
		const permChecker: PermissionChecker = await this.permissionsRepo.getPermissions(env);
		PermissionService._allLoaded = true;
		PermissionService._permissionChecker = permChecker;
		permChecker.permissions.forEach((permission: Permission) => {
			permission.permissions.forEach((level: PermissionAccessLevel) => {
				if (level.defaultGroup) {
					PermissionService._defaultGroups.push(level.groupName);
				}
			});
		});
	}

	get allPermissions(): Permission[] {
		return PermissionService._permissionChecker.permissions;
	}

	getUsersPermissions(user: User): PermissionAccessLevel[] {
		return PermissionService._permissionChecker.getUsersPermissions(user);
	}

	getDisplayablePermissions(user: User): string[] {
		const usersPerms: string[] = [];

		const perms: PermissionAccessLevel[] =  this.getUsersPermissions(user);
		perms.forEach(
			(perm: PermissionAccessLevel) => {
				const permLevel: string = I18NService.getMessage(`org.users.edit.groups.permissions.${ perm.permissionName }.${ perm.label }`);
				const permGroup: string = I18NService.getMessage(`org.users.edit.groups.permissions.${ perm.permissionName }.title`);
				usersPerms.push(`${ permGroup }.${ permLevel }`);
			}
		);

		return usersPerms;
	}

	permitted(user: User, privilege: string): boolean {
		if (PermissionService._permissionChecker) {
			return PermissionService._permissionChecker.permitted(user, privilege);
		} else {
			return false;
		}
	}

	get defaultGroups(): string[] {
		return PermissionService._defaultGroups;
	}
}
